import dayjs from "dayjs";
import React, { useEffect, useMemo } from "react";

import localeData from "dayjs/plugin/localeData";
import { Grid } from "@mui/material";
import RenderMonth from "./RenderMonth";
import { Ttraining } from "../../shared/types/training.type";
import { groupBy, isEmpty } from "lodash";
import { getMonths } from "../../shared/utils/DateUtils";
import { useLocales } from "../../hooks/useLocales";
dayjs.extend(localeData);

type YearViewProps = {
  exams: Ttraining[];
  onMonthClicked: (month: number, exams: Ttraining[]) => void;
};

function YearView({ exams, onMonthClicked }: YearViewProps) {
  const { currentLang } = useLocales();
  const months = getMonths(currentLang);

  const groupedExams = useMemo(() => {
    if (isEmpty(exams)) return {};
    let _exams = exams.map((e) => ({
      ...e,
      month: dayjs(e.creation_date).month() + 1,
    }));

    return groupBy(_exams, (exam) => exam.month);
  }, [exams]);

  return (
    <Grid container spacing={2}>
      {months.map((month, i) => (
        <Grid key={month} item md={2} sm={6} xs={12}>
          <RenderMonth
            monthNumber={i}
            onMonthClicked={(month) =>
              onMonthClicked(month, groupedExams?.[i + 1] ?? [])
            }
            count={groupedExams[i + 1]?.length ?? 0}
            month={month}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default YearView;
